import React from "react";
import { connect } from "react-redux";
import { Alert } from "react-bootstrap";
import { removeUserAlert } from "actions/alertActions";
import "./Alerts.scss";

function Alerts(props) {
  const { alerts, removeUserAlert } = props;
  return (
    <div className="alerts-container">
      {alerts.map((alert) => (
        <Alert
          key={alert.id}
          show={true}
          dismissible
          onClose={() => {
            removeUserAlert(alert.id);
          }}
          variant={alert.variant}
        >
          {alert.content}
        </Alert>
      ))}
    </div>
  );
}

const mapStateToProps = (state) => ({
  alerts: state.alert.alerts,
});

const mapDispatchToProps = {
  removeUserAlert: removeUserAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
